import { useState } from 'react';
import { Outlet } from '@tanstack/react-router';
import { ScrollToTopButton } from '@/components/common/ScrollToTopButton';
import { SidebarInset } from '@/components/ui/sidebar';
import { useSessionExpiredRedirect } from '@/features/auth/hooks/useSessionExpiredRedirect';
import { AppSidebar } from './AppSidebar';
import { AppHeader } from './AppHeader';
import { AppSidebarProvider } from './AppSidebarProvider';
import { AppHeaderTitleSlotContext } from './appHeaderTitleSlot';

export function AppLayout() {
  useSessionExpiredRedirect();
  const [headerTitleSlot, setHeaderTitleSlot] = useState<HTMLDivElement | null>(null);

  return (
    <AppSidebarProvider>
      <AppSidebar />
      <SidebarInset className="min-w-0 bg-app-glow">
        <AppHeader titleSlotRef={setHeaderTitleSlot} />
        <AppHeaderTitleSlotContext.Provider value={headerTitleSlot}>
          <main className="flex flex-1 min-w-0 flex-col px-4 pt-app-gutter-top pb-4 md:px-app-gutter-x md:pb-app-gutter-y">
            <Outlet />
          </main>
        </AppHeaderTitleSlotContext.Provider>
        <ScrollToTopButton />
      </SidebarInset>
    </AppSidebarProvider>
  );
}
